import { createContext, useContext } from "react";

const IntroActiveIndexContext = createContext(0);

export const IntroActiveIndexProvider = IntroActiveIndexContext.Provider;

export function useIntroActiveIndex(): number {
  return useContext(IntroActiveIndexContext);
}

export function useIntroIsActive(slideIndex: number): boolean {
  return useIntroActiveIndex() === slideIndex;
}
